exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n.file-deferred {\r\n  background: #FFD1D1;\r\n}\r\n.file-deferred-waived{\r\n  background: #CCFFCC;\r\n}\r\n[hidden] { display: none !important;}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 727
// module chunks = 2